import { FC, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getHourBalances } from '../../../../@paco/redux/hourBalances/hourBalancesActions'
import { useTypedSelector } from '../../../../@paco/redux/store'

import { LIST_VIEW, PAGE_SIZES } from '../../../../constants'
import { getPayrollPeriods } from '../../../../redux/app/appActions'
import { setEmployeeSearch, setFilter } from '../../../../redux/filter/filterActions'
import { AppFilter } from '../../../../redux/filter-ts/filterModels'
import { Reducers } from '../../../../redux/reducers'
import { useTypedDispatch } from '../../../../redux/store'
import { setStartAndEndDate } from '../../../../redux/weekNavigator/weekNavigatorActions'
import UsersWithHourBalancesOverview from '../../containers/UsersWithHourBalancesOverview/UsersWithHourBalancesOverview'

const ConnectedUsersWithHourBalancesOverview: FC = () => {
    const dispatch = useDispatch()
    const typedDispatch = useTypedDispatch()

    const filter = useSelector((state: Reducers) => state.filterReducer.filter)
    const { departmentOptions } = useTypedSelector(state => state.globalFiltersReducer)
    const {
        roles,
        payrollPeriods,
        employmentTypes,
    } = useSelector((state: Reducers) => state.appReducer)
    const {
        isLoading,
        hourBalances,
    } = useTypedSelector((state) => state.hourBalancesReducer)
    const pagination = useSelector((state: Reducers) => state.paginationReducer)
    const {
        mode: timeMode,
        startDate,
        endDate,
    } = useSelector((state: Reducers) => state.weekNavigatorReducer)
    const {
        departments: userDepartments,
    } = useSelector((state: Reducers) => state.authenticatedUserReducer)

    const onSetFilterChange = (newFilter: AppFilter): void => {
        dispatch(setFilter(newFilter))
    }

    const onSearchBarChange = (search: string): void => {
        dispatch(setEmployeeSearch(search))
    }

    const onSetStartAndEndDate = (selectedDate: Date, newStartDate: Date, newEndDate: Date): void => {
        dispatch(setStartAndEndDate(selectedDate, newStartDate, newEndDate))
    }

    const getUserData = useCallback(async (): Promise<void> => {
        await typedDispatch(getHourBalances(
            startDate,
            endDate,
            timeMode,
            filter,
            {
                start: pagination.number,
                items: pagination.size ?? PAGE_SIZES.SHIFTS[LIST_VIEW],
            },
            userDepartments,
        ))
    }, [departmentOptions, startDate, timeMode, filter, pagination.number, userDepartments])

    useEffect((): void => {
        dispatch(getPayrollPeriods())
    }, [])

    useEffect((): void => {
        getUserData()
    }, [getUserData])

    return (
        <UsersWithHourBalancesOverview
            isLoading={isLoading}
            timeMode={timeMode}
            filter={filter}
            users={hourBalances}
            roles={roles}
            payrollPeriods={payrollPeriods}
            employmentTypes={employmentTypes}
            pagination={pagination}
            onSetFilterChange={onSetFilterChange}
            onSearchBarChange={onSearchBarChange}
            onSetStartAndEndDate={onSetStartAndEndDate}
        />
    )
}

export default ConnectedUsersWithHourBalancesOverview
